import React from 'react';
import PropTypes from 'prop-types';
import singleOrMultiple from '../../../utils/singleOrMultiple';

const CommentsHeader = ({ numberOfComments }) => {
  const commentString = singleOrMultiple('comment', numberOfComments);

  return (
    <div className="comments-header">
      <h2 className="h1 fw-medium comments-title">{numberOfComments} {commentString}</h2>
    </div>
  );
};

CommentsHeader.propTypes = {
  numberOfComments: PropTypes.number,
};

export default CommentsHeader;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentsHeader.js